"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const MobileHamburger = _ref => {
  let {
    toggleActive,
    isActive
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("a", {
    role: "button",
    className: `navbar-burger burger ${isActive ? 'is-active' : ''}`,
    "aria-label": "menu",
    "aria-expanded": "false",
    "data-target": "navigation",
    onClick: () => {
      toggleActive(!isActive);
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    "aria-hidden": "true"
  }), /*#__PURE__*/_react.default.createElement("span", {
    "aria-hidden": "true"
  }), /*#__PURE__*/_react.default.createElement("span", {
    "aria-hidden": "true"
  }));
};
MobileHamburger.propTypes = {
  isActive: _propTypes.default.bool.isRequired,
  toggleActive: _propTypes.default.func.isRequired
};
var _default = exports.default = MobileHamburger;
//# sourceMappingURL=MobileHamburger.js.map